import { render, staticRenderFns } from "./ConfirmDeletionDialog.vue?vue&type=template&id=b198b724&"
import script from "./ConfirmDeletionDialog.vue?vue&type=script&lang=ts&"
export * from "./ConfirmDeletionDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports